import React from 'react';
import { Comment, VoteType } from '../../types/discussion';
import { CommentItem } from './CommentItem';

interface CommentListProps {
  comments: Comment[];
  onVote: (commentId: string, voteType: VoteType) => Promise<boolean>;
  onReply: (text: string, parentId: string) => Promise<boolean>;
}

/**
 * CommentList - Renders list of top-level comments
 * Delegates to CommentItem for rendering (which handles recursion)
 */
export const CommentList: React.FC<CommentListProps> = ({
  comments,
  onVote,
  onReply
}) => {
  if (comments.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          onVote={onVote}
          onReply={onReply}
          depth={0}
        />
      ))}
    </div>
  );
};
